import { createFileRoute } from '@tanstack/react-router';

import { BudgetsView } from '../../../features/cost-to-produce/budgets/budgets-view';
import { usePartnerId } from '../../../features/inbox/use-partner-name';

export const Route = createFileRoute('/operating-costs/cost-to-produce/budgets')({
  staticData: { breadcrumb: 'Budgets' },
  component: BudgetsTab,
});

function BudgetsTab() {
  const partnerId = usePartnerId();
  return <BudgetsView partnerId={partnerId} />;
}
